import { render, staticRenderFns } from "./main.vue?vue&type=template&id=c9a65f5a"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/eazyads-player/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9a65f5a')) {
      api.createRecord('c9a65f5a', component.options)
    } else {
      api.reload('c9a65f5a', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=c9a65f5a", function () {
      api.rerender('c9a65f5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main.vue"
export default component.exports